import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate , useSearchParams } from 'react-router-dom';
import URL from '../constants/ServerUrl';
import apiConnector from '../utils/axios';
const farmerLevelOptions = [
  { value: 1, label: 'Level 1' },
  { value: 2, label: 'Level 2' },
  { value: 3, label: 'Level 3' },
  { value: 4, label: 'Level 4' },
  { value: 5, label: 'Level 5 (Fixed Rate)' },
];

const paymentModeOptions = [
  { value: 'CASH', label: 'Cash' },
  { value: 'CHEQUE', label: 'Cheque' },
  { value: 'BANK', label: 'Bank' },
];

const EditFarmerDetails = ({ route }) => {

  const [mobileNumber, setMobileNumber] = useState('');
  const [farmerName, setFarmerName] = useState('');
  const [farmerLevel, setFarmerLevel] = useState(null);
  const [fixedRate, setFixedRate] = useState(null);
  const [paymentMode, setPaymentMode] = useState('');
  const [bankName, setBankName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [bankHolderName, setBankHolderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigator=useNavigate();
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const token = localStorage.getItem("dairy-token")
  const farmerId=searchParams.get('farmerId')
  const [address,setAddress]=useState('')
  const [loading, setLoading] = useState(false)

  const fetchFarmerData = async () => {
    try {
      setLoading(true)
      if (username) {
        const res = await axios.get(`${URL}admin/${username}/farmer/${farmerId}`, {
          Authorization: `Bearer ${token}`,
        })
        
        const data = res.data;

        setMobileNumber(data.mobileNumber);
        setFarmerName(data.farmerName);
        setFarmerLevel(data.farmerLevel);
        setFixedRate(data.fixedRate);
        setPaymentMode(data.paymentMode);
        setAddress(data.address);
        setBankName(data.bankName);
        setAccountNumber(data.accountNumber);
        setBankHolderName(data.bankHolderName);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchFarmerData();
  }, []);

 
  const updateFarmerData = async () => {
    try {
      if (username) {
        setIsLoading(true);
        const res = await axios.put(`${URL}admin/${username}/farmer/${farmerId}`,
          {
            farmerId,
            mobileNumber,
            farmerName,
            farmerLevel,
            paymentMode,
            bankName,
            address,
            accountNumber,
            bankHolderName,
            fixedRate,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setIsLoading(false);
        alert('Farmer Details Updated Successfully');
        
        // Since the state is already updated, fetching data again might not be necessary
        // fetchFarmerData();
      }
      navigator(-1);
    } catch (error) {
      setIsLoading(false);
      alert('Error in updating farmer details');
      console.error(error);
    }
  };

  return (
    <div className="container mx-auto p-4">
       <h1 className="text-2xl font-bold text-center text-blue-600 mb-6">EDIT FARMER</h1>
    <form className="max-w-md mx-auto">
      {farmerId >= 1 && (
        <input
          type="text"
          placeholder="Farmer ID"
          value={String(farmerId)}
          readOnly
          className="border border-gray-300 rounded-md w-full p-2 mb-4"
        />
      )}
      <input
        type="text"
        placeholder="Mobile Number"
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      />
      <input
        type="text"
        placeholder="Farmer Name"
        value={farmerName}
        onChange={(e) => setFarmerName(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      />
  
      <select
        value={farmerLevel}
        onChange={(e) => setFarmerLevel(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      >
        {farmerLevelOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {farmerLevel === 5 && (
        <input
          type="text"
          placeholder="Fixed Rate"
          value={fixedRate || ''}
          onChange={(e) => setFixedRate(e.target.value)}
          className="border border-gray-300 rounded-md w-full p-2 mb-4"
        />
      )}
      <select
        value={paymentMode}
        onChange={(e) => setPaymentMode(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      >
        {paymentModeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Address"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      />
  
      <input
        type="text"
        placeholder="Bank Name"
        value={bankName}
        onChange={(e) => setBankName(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      />
      <input
        type="text"
        placeholder="Bank Account Number"
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      />
      <input
        type="text"
        placeholder="Bank Holder Name"
        value={bankHolderName}
        onChange={(e) => setBankHolderName(e.target.value)}
        className="border border-gray-300 rounded-md w-full p-2 mb-4"
      />
  
      <button
        onClick={updateFarmerData}
        disabled={isLoading}
        className={`w-full bg-blue-500 text-white font-semibold py-2 px-4 rounded-md ${
          isLoading ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        {isLoading ? 'Updating...' : 'Update'}
      </button>
    </form>
  </div>
  
  
  );
};

export default EditFarmerDetails;
